module.exports = __webpack_public_path__ + "img/sv6.45ec51af.svg";